export const drawerWidth = 240;
export const pageMaxWidth = 1324;
export const ORGANIZATION_TIME_ZONE = 'Europe/Athens';
